module.exports = __webpack_public_path__ + "img/icon04.2809032.png";